import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsHttpService {
  private url = environment.serverUrl;

  constructor(private http: HttpClient) {
  }

  changePassword(body: any): Observable<any> {
    return this.http.post(`${this.url}/user/change_password/`, body);
  }

  changeMessageNotification(body: any): Observable<any> {
    return this.http.post(`${this.url}/user/message_notification/`, body);
  }

  getUserDetails(){
    return this.http.get(`${this.url}/user/user_detail/`);
  }

  updateUserDetails(id: number, body: any) {
    return this.http.put(`${this.url}/user/user_detail/`, body);
  }

  uploadUserImage(formData: FormData) {
    return this.http.post(`${this.url}/user/photo_upload/`, formData);
  }

  getUserList(){
    return this.http.get(`${this.url}/user/list`);
  }
  
  getRiskParams() {
    return this.http.get(`${this.url}/utils/country`);
  }

  setRiskParam(country) {
    return this.http.post(`${this.url}/utils/country/`, country)
  }
}
